// extracted by mini-css-extract-plugin
module.exports =  {"label":"_0d624b9a27--label--mCUN7"};